import { data } from 'autoprefixer';
import axios from 'axios';
import Pagination from '../component/paginations/pagination';

const InvoiceApi = {};

const nonce = devsAccountingApi.nonce;


// Pagination
InvoiceApi.index = async (params = null) => {
    const url = '/wp-json/devs-accounting/v1/invoices/';
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

InvoiceApi.show = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/show-invoice/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

InvoiceApi.delete = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/delete-invoice/' + id;
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

InvoiceApi.save = async (data) => {
    let url = "/wp-json/devs-accounting/v1/add-invoice/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return error.response.data; });
    return res;
}

InvoiceApi.update = async (input) => {
    let url = "/wp-json/devs-accounting/v1/update-invoice/" + input.id;
    const data = {nonce: nonce, ...input};
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return []; });
    return res;
}

InvoiceApi.sendMails = async (id) => {
    let url = "/wp-json/devs-accounting/v1/send-mail/" + id;
    const res = await axios.get(url)
        .then(response => {
            return response.data;
        }).catch(error => { return []; });
    return res;
}

export default InvoiceApi;